import { SideNav } from "components";
import { Ptag } from "components/core/fonts";
import { DashboardWrapper, Header } from "pages/MainDashboard/styles";
import React from "react";
import styled from "styled-components";
import { useState } from "react";
import { useMemo } from "react";
import { useNavigate } from "react-router";
import routes from "components/routes";
import { LargeButton } from "components/core";
import http from "services/httpService";

const name = localStorage.getItem("name");
const email = localStorage.getItem("email");
function ChangePassword() {
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState({
    base: "",
    confirmation: "",
  });

  const error = useMemo(() => {
    if (!newPassword.base || !newPassword.confirmation) return false;
    if (newPassword.base != newPassword.confirmation) return true;
  }, [newPassword]);

  const resetPasswordHandler = async () => {
    try {
      const data = http.post("/users/update_password/", {
        email: email,
        password: newPassword.confirmation,
      });
      navigate(`/`);
    } catch (ex) {
      alert(ex.response["data"]);
    }
  };
  return (
    <>
      <SideNav />
      <DashboardWrapper>
        <Header>
          <Ptag
            fontSize="26px"
            letterHeight="44px"
            fontWeight="600"
            fontFamily="Merriweather"
          >
            {name ? `Hello ${name}` : "Welcome to Vital"}
          </Ptag>
        </Header>
        <div style={{ paddingTop: "4rem" }}>
          <Ptag
            fontSize="24px"
            fontWeight="700"
            style={{ paddingBottom: "36px" }}
          >
            Reset Password
          </Ptag>
          <div
            style={{ display: "flex", gap: "2rem", flexDirection: "column" }}
          >
            <div>
              <Ptag fontSize="18px" marginBottom="1rem">
                New Password
              </Ptag>
              <PhoneInputWrapper>
                <PhoneInput
                  type="password"
                  value={newPassword.base}
                  onChange={(e) => {
                    e.persist();
                    setNewPassword((prev) => ({
                      ...prev,
                      base: e.target.value,
                    }));
                  }}
                  pattern="[A-Za-z]{3}"
                  maxLength="10"
                />
              </PhoneInputWrapper>
            </div>
            <div>
              <Ptag fontSize="18px" marginBottom="1rem">
                Confirm Password
              </Ptag>
              <PhoneInputWrapper>
                <PhoneInput
                  type="password"
                  value={newPassword.confirmation}
                  onChange={(e) => {
                    e.persist();
                    setNewPassword((prev) => ({
                      ...prev,
                      confirmation: e.target.value,
                    }));
                  }}
                  pattern="[A-Za-z]{3}"
                  maxLength="10"
                />
                {error && <Error>Password is not matching</Error>}
              </PhoneInputWrapper>
            </div>
            <LargeButton
              fontSize="18px"
              onClick={() => resetPasswordHandler()}
              label="Submit"
              marginTo="4rem"
              style={{ maxWidth: "800px" }}
            />
          </div>
        </div>
      </DashboardWrapper>
    </>
  );
}

export default ChangePassword;

export const PhoneInputWrapper = styled.div`
  position: relative;
  /* margin: 8rem 0rem 12rem 0rem; */
  width: 500px;
  & > p {
    color: #4a4a4a;
    position: absolute;
    left: 2rem;
    z-index: 99;
    top: 50%;
    margin-top: 0.1rem;
    transform: translateY(-50%);
    font-size: 16px;
    font-weight: 600;
    pointer-events: none;
    user-select: none;
  }
  & > div {
    width: 1px;
    height: 40%;
    margin-top: 0.1rem;
    background-color: #4a4a4a;
    z-index: 999;
    position: absolute;
    left: 6rem;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    user-select: none;
  }
`;

export const PhoneInput = styled.input`
  width: 100%;
  background-color: transparent;
  padding: 1.6rem 2rem 1.6rem 2rem;
  outline: none;
  font-weight: 600;
  border: none;
  border: 1px solid #231a3d;
  border-radius: 10px;
  font-size: 16px;
  color: ${(props) => props.theme.accentColor};
  letter-spacing: 2px;
`;

export const Error = styled.span`
  color: red;
  font-size: 1.4rem;
  z-index: 9;
  position: absolute;
  bottom: -3rem;
  left: 0;
`;
